/* eslint-disable no-param-reassign */
import L from 'leaflet';
import { forEach } from 'lodash';

const SVG_ARROW_SRC = '/maps-buttons/flecha_logo.svg';
const SVG_ARROW_STYLE = `
  position: relative;
  left: 20px;
  width: 34px;
  height: 34px;
  transform: scaleX(-1);
`;
const SVG_HAND_SRC = '/maps-buttons/mano.svg';
const SVG_HAND_STYLE = `
  position: relative;
  right: 34px;
  top: 18px;
  width: 34px;
  height: 34px;
  z-index: -1;
  opacity: 1;
  transition: opacity 0.2s;
`;
const CONTAINER_STYLE = `
  cursor: pointer;
  margin-bottom: -26px;
`;

L.Control.CollapseButton = L.Control.extend({
  options: {
    position: 'topleft'
  },
  initialize(options) {
    L.Util.setOptions(this, options);
  },
  onAdd(map) {
    this.map = map;
    map.collapseButton = this;
    this.container = L.DomUtil.create('div', 'leaflet-custom-Collapse');
    const svgArrow = L.DomUtil.create('img', '', this.container);
    this.svgHand = L.DomUtil.create('img', '', this.container);
    const { container, svgHand } = this;
    container.title = 'Expandir';
    container.style.cssText = CONTAINER_STYLE;
    svgArrow.style.cssText = SVG_ARROW_STYLE;
    svgArrow.src = SVG_ARROW_SRC;
    svgHand.style.cssText = SVG_HAND_STYLE;
    svgHand.src = SVG_HAND_SRC;
    container.clicked = false;

    L.DomEvent.disableClickPropagation(container);
    L.DomEvent.on(container, 'click', this.click, this);

    return container;
  },
  click() {
    if (this.options.collapsible) {
      if (!this.container.clicked) {
        this.expand();
      } else {
        this.collapse();
      }
    }
  },
  expand() {
    this.container.clicked = true;
    this.container.title = 'Cerrar';
    const topLeft = this.container.parentElement;
    const buttons = topLeft.children;
    let isFirst = true;
    forEach(buttons, button => {
      if (isFirst) {
        isFirst = false;
      } else {
        button.style.visibility = 'visible';
        button.style.opacity = 1;
        button.style.bottom = '0px';
      }
    });
    this.svgHand.style.zIndex = '-1';
    this.svgHand.style.opacity = 0;
  },

  collapse() {
    this.container.clicked = false;
    this.container.title = 'Expandir';
    const topLeft = this.container.parentElement;
    const buttons = topLeft.children;
    let isFirst = true;
    forEach(buttons, button => {
      if (isFirst) {
        isFirst = false;
      } else {
        button.style.opacity = 0;
        button.style.bottom = '200px';
        setTimeout(() => {
          button.style.visibility = 'hidden';
        }, 300);
      }
    });
    this.svgHand.style.zIndex = '1';
    this.svgHand.style.opacity = 1;
  }
});

L.control.collapsebutton = (layer, opts) => new L.Control.CollapseButton(layer, opts);

/**
 * Adds a title button to the map.
 *
 * @param {object} leafletMap - The leaflet map.
 * @param {boolean} collapsible - If the button should collapse on click.
 */
const customCollapseButton = (leafletMap, collapsible = true) =>
  L.control.collapsebutton({ collapsible }).addTo(leafletMap);

export default customCollapseButton;
